.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  width: 100%;
}

.badge {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
  font-variant-numeric: tabular-nums;
}

.empty {
  color: var(--tuna-content-muted);
  font-size: var(--tuna-typography-body2-fontSize);
  padding: var(--tuna-spacing-2);
}
